"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSessionInfo = void 0;
exports.userSessionInfo = `
    (function (){ try { var s=window['sessionStorage'],x='__storage_test__',r='PFS_ORIG_REFERER',pv='PFS_PAGE_VIEW',v=null; s.setItem(x, x); s.removeItem(x); if (s.getItem(r) === null) { s.setItem(r, document.referrer); } v=s.getItem(pv); v === null ? s.setItem(pv, 1) : s.setItem(pv, parseInt(v, 10) + 1); } catch (e) { return; } }());
`;
